// extracted by mini-css-extract-plugin
export default {"cluster-screen":"Assets_cluster-screen__MoGoo","mapWrapper":"Assets_mapWrapper__OQGem","container":"Assets_container__JzwZL","dispatch":"Assets_dispatch__EUlkO"};